import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DropdownLanguage from "./dropdown/language.jsx";
import DropdownProfile from "./dropdown/profile.jsx";
import DropdownMegaMenu from "./dropdown/mega.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import Logo from "../../assets/Broward-Partnerships-for-kids-logo.png";
import { reportActions } from "../../_store/reports.slice.js";

function Header() {
  const dispatch = useDispatch();
  const menu_list = useSelector((state) => state?.auth?.menu_list);
  const handleMigrate = () => {
    //
    dispatch(reportActions.userMigration());
  };

  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMobile,
        toggleAppSidebarEnd,
        toggleAppSidebarEndMobile,
        toggleAppTopMenuMobile,
        appHeaderLanguageBar,
        appHeaderMegaMenu,
        appHeaderInverse,
        appSidebarTwo,
        appTopMenu,
        appSidebarNone,
        appSidebarMinify,
      }) => (
        <div
          id="header"
          className="app-header"
          data-bs-theme={appHeaderInverse ? "dark" : ""}
        >
          <div
            className={`navbar-header p-2 ${appSidebarMinify ? "minified" : ""
              }`}
          >
            {appSidebarTwo && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarEndMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            <a
              href="/Home"
              // target="_blank"
              // to={
              //   menu_list &&
              //   Array.isArray(menu_list) &&
              //   menu_list.length > 0 &&
              //   menu_list[0]?.ManagementMenuID !== 1000 // for avoid maintenance menu when click logo
              //     ? menu_list[0].URLPath
              //     : "/Home"
              // }
              className="text-decoration-none d-flex justify-content-between align-item-center w-100"
            >
              <img className="Sidebarlogo" src={Logo} alt="small-logo"></img>
            </a>

            {appHeaderMegaMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#top-navbar"
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appTopMenu && !appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appSidebarNone && appTopMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            {!appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
          </div>

          {appHeaderMegaMenu && <DropdownMegaMenu />}

          <div className="navbar-nav">
            {/* <button
              onClick={() => {
                handleMigrate();
              }}
            >
              ..
            </button> */}
            <a
              href={`${process.env.REACT_APP_API_URL}/users/ccAuth`}
              target="_blank"
              rel="noopener noreferrer"
              className="rds-link"
              title="Constant Contact connect"
              aria-label="Connect to Constant Contact (opens in a new tab)"
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 164 164"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-label="Constant Contact Logo"
                className="r-h-8 r-w-8"
              >
                <path
                  d="M75.4 163.3C30.5 163.3 0 126.7 0 87.8C0 48.3 31.1 14.2 72.5 12.6C74.1 12.5 75.5 13.9 75.5 15.5V27.6C75.5 29.1 74.3 30.4 72.7 30.5C42.3 31.9 17.8 56.8 17.8 87.9C17.8 118.3 41.8 145.5 75.4 145.5C108.1 145.5 131.3 119.4 132.7 90.6C132.8 89.1 134 87.8 135.6 87.8H147.7C149.3 87.8 150.6 89.1 150.6 90.8C149.2 129.2 118.3 163.3 75.4 163.3Z"
                  fill="#1856ED"
                ></path>
                <path
                  d="M75.5 123.3C55.5 123.3 40 107.4 40 87.8C40 69.5 54.1 54.2 72.4 52.7C74.1 52.6 75.5 53.9 75.5 55.6V67.7C75.5 69.1 74.5 70.4 73 70.6C64.2 71.8 57.8 79.3 57.8 87.9C57.8 97.5 65.3 105.6 75.5 105.6C84 105.6 91.6 99.2 92.8 90.4C93 89 94.3 87.9 95.7 87.9H107.8C109.5 87.9 110.8 89.3 110.7 91C109.1 108.9 94.1 123.3 75.5 123.3Z"
                  fill="#1856ED"
                ></path>
                <path
                  d="M145.2 73C143.8 43.7 120.4 19.5 90.3 18.1C88.8 18 87.5 16.8 87.5 15.2V3.20005C87.5 1.60005 88.8 0.300049 90.5 0.300049C129.6 1.80005 161.5 33.1 163 72.8C163.1 74.4 161.7 75.8 160.1 75.8H148C146.6 75.8 145.3 74.6 145.2 73Z"
                  fill="#FF9E1A"
                ></path>
                <path
                  d="M90.8 58.4001C89 58.1001 87.7 56.6001 87.7 55.1001V43.3001C87.7 41.6001 89.1 40.3001 90.8 40.4001C108.2 41.9001 121.6 55.8001 123.1 72.6001C123.2 74.3001 121.9 75.7001 120.2 75.7001H107.5C106.3 75.7001 105.4 74.9001 105.2 73.7001C104.3 66.6001 98.9 59.8001 90.8 58.4001Z"
                  fill="#FF9E1A"
                ></path>
              </svg>
            </a>
            {appHeaderLanguageBar && <DropdownLanguage />}
            <DropdownProfile />
            {appSidebarTwo && (
              <div className="navbar-divider d-none d-md-block"></div>
            )}
            {appSidebarTwo && (
              <div className="navbar-item d-none d-md-block">
                <Link
                  to="/"
                  onClick={toggleAppSidebarEnd}
                  className="navbar-link icon"
                  aria-label="Toggle sidebar menu"
                >
                  <i className="fa fa-th"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </AppSettings.Consumer>
  );
}

export default Header;
